import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './LanguageContext';
import { initAll } from 'govuk-frontend';

// Initialise GOV.UK Frontend JS once
try {
  initAll();
} catch (err) {
  // Keep going even if GOV.UK JS fails to load
  console.warn('[govuk] initAll failed', err);
}
document.documentElement.classList.add('govuk-frontend-supported', 'js-enabled');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
